import { NewPlenaryPage } from '@hendrx/core/plenary/pages/NewPlenaryPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/plenary/new')({
  component: NewPlenaryWrapper
});

function NewPlenaryWrapper() {
  return <NewPlenaryPage />;
}
